export default __webpack_public_path__ + "static/media/Zaheer Ahmed.9b168f27.jpeg";